import { render } from "./ExpandableClass.vue?vue&type=template&id=7e7bb12d&scoped=true&ts=true"
import script from "./ExpandableClass.ts?vue&type=script&lang=ts"
export * from "./ExpandableClass.ts?vue&type=script&lang=ts"

import "./ExpandableClass.vue?vue&type=style&index=0&id=7e7bb12d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e7bb12d"]])

export default __exports__